import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { Validators } from '@angular/forms';

import { finalize, map } from 'rxjs/operators';

import {
  Observable,
  merge,
  of,
} from 'rxjs';

import { CustomValidators } from '../../../../../common/custom-validation/custom-validators';
import { InternetbankAppApplicationException } from '../../../../../common/exceptions/exceptions';
import { FieldOptions } from '../../../../../ui/controls/field.model';
import { SelectItem } from '../../../../../ui/controls/select-field/select-item';
import { CustomFormControl } from '../../../../../ui/custom-reactive-forms/custom-form-control';
import { CustomFormGroup } from '../../../../../ui/custom-reactive-forms/custom-form-group';
import { PaymentTypeEnum } from '../../../transfers/budget-transfer-search/budget-transfer-search.service';
import { DocumentTypes } from '../payment-widgets.service';
import { ChargeForWidget } from '../shared/charge-item/change-item-entites';
import { WidgetBaseDirective } from '../shared/widget-base-component';

import { PaymentWidgetData } from './../payment-widget-data';

@Component({
	selector: 'app-widget-fines',
	templateUrl: './widget-fines.component.html',
	styleUrls: ['./widget-fines.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class WidgetFinesComponent extends WidgetBaseDirective
	implements OnInit {

	public PaymentTypeGIBDDPay = PaymentTypeEnum.GIBDD_PAY;

	public ngOnInit(): void {
		this.searchForm = new CustomFormGroup({
			typeSelect: new CustomFormControl(
				new FieldOptions({
					'@type': 'select-field',
					name: 'typeSelect',
					items: [
						new SelectItem(
							'Уникальный идентификатор начисления',
							DocumentTypes.UIN,
						),
						new SelectItem(
							'Водительское удостоверение',
							DocumentTypes.DRIVING_LICENSE,
						),
						new SelectItem(
							'Свидетельство о регистрации ТС',
							DocumentTypes.CAR_CERTIFICATE,
						),
					],
				}),
			),
			searchText: new CustomFormControl(
				new FieldOptions({
					'@type': 'text-field',
					name: 'searchText',
					required: true,
				}),
			),
		});

		const typeSelectControl: CustomFormControl | null = this.searchForm.getControlFromAllLevels('typeSelect');
		const searchTextControl: CustomFormControl | null = this.searchForm.getControlFromAllLevels('searchText');

		typeSelectControl?.valueChanges
			.subscribe((x: DocumentTypes) => {
				searchTextControl?.setValue(null, {
					onlySelf: true,
					emitEvent: false,
				});

				switch (x) {
					case DocumentTypes.UIN: {
						if (searchTextControl) {
							// searchTextControl.fieldOptions.placeholder = 'ИНД';
							searchTextControl.fieldOptions.hints = {underLineHint: '20 или 25 цифр'};
							searchTextControl.fieldOptions.inputMask = {
								mask: '9{20,25}',
								autoUnmask: true,
								showMaskOnFocus: true,
								showMaskOnHover: false,
							};
							searchTextControl.fieldOptions.inputMode = 'numeric';
							searchTextControl.setValidators([
								Validators.required,
								CustomValidators.uinLength(),
								CustomValidators.uin(),
							]);
						}

						break;
					}
					case DocumentTypes.DRIVING_LICENSE:
					case DocumentTypes.CAR_CERTIFICATE: {
						if (searchTextControl) {
							// searchTextControl.fieldOptions.placeholder = 'ВУ или СТС';
							searchTextControl.fieldOptions.hints = {underLineHint: '10 символов'};
							searchTextControl.fieldOptions.inputMask = {
								mask: '99 ** 999999',
								autoUnmask: true,
								showMaskOnFocus: true,
								showMaskOnHover: false,
								definitions: {'*': {validator: '[0-9а-яА-Яa-zA-Z]'}},
							};
							searchTextControl.setValidators([
								Validators.required,
								CustomValidators.patternWithMessage(
									/^[0-9]{2}[0-9а-яА-Яa-zA-Z]{2}[0-9]{6}$/,
									'Введено некорректное значение',
								),
							]);
						}
						break;
					}
				}

				searchTextControl?.updateValueAndValidity({emitEvent: false});
			});

		merge(
			typeSelectControl?.valueChanges || of(undefined),
			searchTextControl?.valueChanges || of(undefined),
		)
			.subscribe(() => {
				this.chargeWidget.searcErrors = null;
				searchTextControl?.markAsPristine();
				this.charges = [];
			});

		typeSelectControl
			?.onTemplateControlInit
			.subscribe(() => {
				typeSelectControl.setValue(typeSelectControl.fieldOptions.items?.[0].value);
			});

		this.onTabSubscriptionActivate();
	}


	public onTabSubscriptionActivate(): void {
		this.paymentWidgetsServiceService
			.getFinesOnSubscription()
			.pipe(
				finalize(() => {
					this.changeDetectorRef.markForCheck();
				}),
			)
			.subscribe((data: PaymentWidgetData) => {
				this.charges = data.accruals;
				this.subscriptionsAbsence = data.subscriptionsAbsence;
			});
	}
	public onTabSearchActivate(): void {
	}
	public search(): void {

		this.chargeWidget.searcErrors = null;

		const typeSelectControl: CustomFormControl | null = this.searchForm.getControlFromAllLevels('typeSelect');
		const searchTextControl: CustomFormControl | null = this.searchForm.getControlFromAllLevels('searchText');

		if (searchTextControl?.invalid) {
			return;
		}

		this.chargeWidget.startSearch();

		let search$: Observable<Array<ChargeForWidget>> | undefined;
		switch (typeSelectControl?.value) {
			case DocumentTypes.UIN:
				search$ = this.paymentWidgetsServiceService
					.searchOnUin(searchTextControl?.value)
					.pipe(map((data: ChargeForWidget) =>
						data ? [data] : []));
				break;
			case DocumentTypes.DRIVING_LICENSE:
			case DocumentTypes.CAR_CERTIFICATE:
				search$ = this.paymentWidgetsServiceService
					.searchOnDocument(typeSelectControl?.value, searchTextControl?.value);
				break;
			default:
				break;
		}
		if (search$) {
			search$
				.pipe(
					finalize(() => {
						this.chargeWidget.stopSearch();
						this.changeDetectorRef.markForCheck();
					}),
				)
				.subscribe(
					(data: Array<ChargeForWidget>) => {
						this.charges = data;
						this.chargeWidget.startSearch();
					},
					(error: InternetbankAppApplicationException) => {
						this.chargeWidget.searcErrors = error.errors || null;
					});
		}

	}

	public handleKeyDown(event: KeyboardEvent): void {
		if (event.keyCode === 13) {
			// 'enter' pressed
			this.search();
		}
	}
}
